import { InputTableActionBarV2 } from '@/components/custom/erp';
import type { SelectedCellInfo } from '../hooks/useTaxRows';
import type { FormMode } from '@/types/form';

interface ActionBarProps {
  formMode: FormMode;
  ma_ngv?: string;
  handleAddRow?: () => void;
  handleDeleteRow?: () => void;
  handleCopyRow?: () => void;
  handlePasteRow?: (clipboardText?: string) => void | Promise<void>;
  selectedCell?: SelectedCellInfo | null;
  handleMoveRow?: (direction: 'up' | 'down') => void;
  handleExport?: () => void;
  handlePin?: () => void;
  handleViewInventory?: () => void;
  handleViewReceipt?: () => void;
  isPasting?: boolean;
}

export default function ActionBar({ ma_ngv, ...props }: ActionBarProps) {
  return (
    <InputTableActionBarV2
      {...props}
      disabled={type => props.formMode === 'view' || (type === 'add' && ma_ngv === '1')}
    />
  );
}
